import { Section } from "@/components/sections"
import { BodyDefaultLight, Heading2, Heading4 } from "@/components/text"
export type WhyBlock = { title: string; description: React.ReactNode }

const WhyColumnsSection: React.FC<{ title: string; data: WhyBlock[] }> = ({ title, data }) => {
  return (
    <Section>
      <Heading2 className="mb-20">{title}</Heading2>
      <WhySection whyBlocks={data} />
    </Section>
  )
}

type WhySectionProps = {
  whyBlocks: WhyBlock[]
}
const WhyBlock: React.FC<WhyBlock> = ({ title, description }) => (
  <div className="flex-1 ">
    <span className="h-[48px] w-[48px] flex items-center justify-center rounded-full mb-6">
      <svg width="28" height="28" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.99997 8.58597L1.70697 5.29297L0.292969 6.70697L4.99997 11.414L14.707 1.70697L13.293 0.292969L4.99997 8.58597Z"
          className="fill-purple"
        />
      </svg>
    </span>
    <Heading4 className="mb-4">{title}</Heading4>
    <BodyDefaultLight>{description}</BodyDefaultLight>
  </div>
)

const WhySection: React.FC<WhySectionProps> = ({ whyBlocks }) => (
  <div className="flex md:space-x-10 px-4 md:px-0 flex-col md:flex-row">
    {whyBlocks.map((block, index) => (
      <WhyBlock key={index} title={block.title} description={block.description} />
    ))}
  </div>
)

export default WhyColumnsSection
